import humanize from 'humanize-number';

/**
 * Utility functions for formatting values
 */

/**
 * Format a number as Indian currency (INR)
 */
export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(amount);
}

/**
 * Format a number as Indian currency (INR) in readable format
 */
export function readableCurrency(amount: number, locale: 'IN' | 'US'): string {
  return humanize(amount, {
    system: locale === 'IN' ? 'indian' : 'western',
    short: true,
  });
}

/**
 * Format a date string to localized format
 */
export function formatDate(date: string): string {
  return new Date(date).toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

/**
 * Format a number to compact notation with suffix (K, M, B)
 */
export function formatCompactNumber(number: number) {
  return new Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short',
  }).format(number);
}

export function formatBytes(bytes: number, decimals = 2) {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
